import { applyWeightedDiffs, getDiff } from '../change-product-budget/utils';

function patch(campaign, change, campaignLinesById) {
  const rows = Object.values(change.productAggregates);
  const changedCampaignLines = {};

  rows.forEach(({ lineIds, newValues, oldValues }) => {
    const lines = lineIds.map(id => campaignLinesById[id]);
    const diff = getDiff(newValues, oldValues);

    if (Object.values(diff).every(val => val === 0)) return;

    applyWeightedDiffs(lines, diff).forEach(line => {
      changedCampaignLines[line.id] = Object.fromEntries(
        Object.entries(line).map(([key, val]) => {
          return [key, Math.round(val * 100) / 100];
        }),
      );
    });
  });

  const getPatchPayload = () => {
    const fixedPayload = {
      campaignLines: Object.values(campaignLinesById).map(({ id }) =>
        changedCampaignLines[id] ? changedCampaignLines[id] : { id },
      ),
    };
    if (campaign.commercialIncentive || !change.commercialIncentive)
      return {
        ...fixedPayload,
      };

    return {
      commercialIncentive: change.commercialIncentive,
      ...fixedPayload,
    };
  };

  return getPatchPayload();
}

export default patch;
